import React from 'react';
import { PropTypes } from 'prop-types';

import ServicesMenuItem from './ServicesMenuItem';

import { TitleTypes } from '../../../Title';

import Text, { TextTypes } from '../../../Text';

const ServicesMenu = ({ styles, slides, activeIndex, moveToSlideId, title, rules, titleAs }) => {
    const handleClick = (e, id) => {
        e.stopPropagation();
        moveToSlideId(id);
    };

    return (
        <div data-current-carousel-slide={`${activeIndex + 1};${slides.length}`} className={styles.container}>
            <Text extend={rules.extendText} as={titleAs} type={TextTypes.SECTION}>
                {title}
            </Text>
            {slides.map((item, index) => {
                return (
                    <ServicesMenuItem
                        key={item.id}
                        serviceName={item.serviceName}
                        isActive={index === activeIndex}
                        onClick={e => handleClick(e, index)}
                    />
                );
            })}
        </div>
    );
};

ServicesMenu.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
    slides: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    activeIndex: PropTypes.number.isRequired,
    moveToSlideId: PropTypes.func.isRequired,
    title: PropTypes.node.isRequired,
    rules: PropTypes.shape().isRequired,
    titleAs: PropTypes.string,
};

ServicesMenu.defaultProps = {
    titleAs: TitleTypes.H2,
};

export default ServicesMenu;
